var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100px"}},[_c('fm-input-number',{attrs:{"size":"small"},on:{"change":_vm.change},model:{value:(_vm.currentVolume),callback:function ($$v) {_vm.currentVolume=$$v},expression:"currentVolume"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }